import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Loader } from "../../components";
import Form from "./setting components/Form";
import { useAxios, useComponent } from "../../hooks";

export default function AgentChannelSetting() {
  const axios = useAxios();
  const { loader } = useComponent();
  const { activeBrand, accessToken } = useSelector(
    (state) => state.memberDetails
  );

  const cpassAxios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  const [agents, setAgents] = useState([]);
  const [columns, setColumns] = useState({});
  const [agentCreated, setAgentCreated] = useState("");

  useEffect(() => {
    loader.start(3);
    axios({
      url: "/get/brandAgentDetails",
      method: "POST",
      data: {
        brand_id: activeBrand.ID,
      },
    }).then((response) => {
      if (response.status) {
        let data = [];
        for (let agent of response.data) {
          let values = [];
          let agentIDs = [];

          let key = Object.keys(agent);
          for (let agentKey of agent[key[2]]) {
            agentIDs.push(agentKey.agent_id);
          }

          cpassAxios({
            url: "/bot/agents",
            method: "POST",
            data: agentIDs,
          }).then((response) => {
            if (response.status) {
              values.push(...response.data);
            }
          });

          data = [
            ...data,
            {
              channelID: agent.channel_id,
              channelLogo: agent.channel_logo,
              channelName: key[2],
              [key[2]]: values,
            },
          ];

          cpassAxios({
            url: "/bot/get-agent-fields/" + agent.channel_id,
          }).then((response) => {
            if (response.status) {
              for (let field of response.data.data) {
                setColumns((prev) => ({
                  ...prev,
                  [agent.channel_id]: handleColumns(prev[agent.channel_id]),
                }));

                function handleColumns(val = []) {
                  val.push({
                    label: field.label,
                    name: field.name,
                    options: {
                      customBodyRender: (value) => {
                        return value?.length > 40
                          ? value?.substring(0, 39) + "....."
                          : value;
                      },
                    },
                  });
                  return val;
                }
              }
            }
          });
        }

        setAgents(data);
        loader.apiComplete(3);
      }
    });
  }, [axios, activeBrand.ID, loader, cpassAxios]);
  return (
    <Loader>
      <Form
        columns={columns}
        agentCreated={agentCreated}
        setAgentCreated={setAgentCreated}
        agents={agents}
        setAgents={setAgents}
        setColumns={setColumns}
      />
    </Loader>
  );
}
